<template>
  <!-- Sticky Menu  -->
  <div
    :class="{
      'Sticky-inpage-menu scroll-smooth border-b border-www-color-primary-very-light': true,
      'hidden md:block': true,
    }"
  >
    <div
      :class="{
        'container mx-auto': true,
      }"
    >
      <ul
        ref="stickyMenu"
        :class="{
          'relative flex justify-evenly': true,
        }"
        @mouseleave="resetLine"
      >
        <span
          :class="{
            'h-1 bg-www-color-primary-dark': true,
            'absolute bottom-0 transition-all duration-300': true,
          }"
          :style="{
            left: `${lineStyle.left}px`,
            width: `${lineStyle.width}px`,
          }"
        ></span>
        <li
          v-for="(section, index) in anchorList"
          :key="section.anchorId"
          :ref="(el) => (menuItems[index] = el as HTMLLIElement)"
          :class="{
            'w-max text-center': true,
            'text-13px font-bold uppercase': true,
            'mr-4 py-5': true,
            'cursor-pointer': true,
            'text-www-color-primary-dark': index === activeIndex,
          }"
          @mouseenter="moveLine(index)"
          @click="handleClick(index)"
        >
          <NuxtLink @click.prevent="scrollToSection(section.anchorId)">
            {{ section.label }}
          </NuxtLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue';
import type { SectionBuilderAnchorMenu } from '~/sanity/types';
defineProps<SectionBuilderAnchorMenu>();

const stickyMenu = useTemplateRef('stickyMenu');
const menuItems = ref<(HTMLLIElement | null)[]>([]);
const activeIndex = ref(0);
const lineStyle = ref({
  left: 0,
  width: 0,
});

const handleClick = (index: number) => {
  activeIndex.value = index; // Set the clicked item as active
  moveLine(index); // Move the line to the clicked item
};

const moveLine = (index: number) => {
  const item = menuItems.value[index];
  if (!item || !stickyMenu.value) return;
  const menuOffsetLeft = stickyMenu.value.getBoundingClientRect().left;
  const itemOffsetLeft = item.getBoundingClientRect().left;
  const itemWidth = item.clientWidth;

  lineStyle.value = {
    left: itemOffsetLeft - menuOffsetLeft,
    width: itemWidth,
  };
};
const resetLine = () => {
  if (activeIndex.value !== null) {
    moveLine(activeIndex.value); // Keep the line under the active (clicked) item
  } else {
    lineStyle.value = {
      left: 0,
      width: 0,
    };
  }
};
// This is to ensure the line is positioned correctly on initial load
// and when the component is mounted
onMounted(() => {
  if (menuItems.value.length > 0) {
    moveLine(activeIndex.value);
  }
});
</script>

<style lang="scss" scoped></style>
